import { TTrialModalState } from 'store';

export const trialModalInitialState: TTrialModalState = {
  isModalVisible: false,
  timerId: null
};
